// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__VNhcc","colMaxWidth":"Table_colMaxWidth__3L6y_"};